import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Col, Row, Card } from 'antd';
import MainLayout from '../../../components/MainLayout/MainLayout';
import UsersTable from '../components/UsersTable/UsersTable';
import { fetchUsersRequest } from '../../../redux/reducers/clients/clientsSlice';
import { useParams } from 'react-router-dom';
import PageHeader from '../../../components/PageHeader/PageHeader';

const Users = () => {
    const { t } = useTranslation('clients');
    const dispatch = useDispatch();
    const { companyId } = useParams<{ companyId: string }>();
    const breadcrumbCrumbs = [
        { title: 'dashboard', path: '/dashboard' },
        { title: 'clients', path: '/clients' },
        { title: 'users' }
    ];
    useEffect(() => {
        dispatch(fetchUsersRequest(companyId!));
    }, [dispatch]);

    return (
        <MainLayout>
            <PageHeader
                crumbs={breadcrumbCrumbs}
            />
            <Col className='base-title-typography' style={{ display: "flex", justifyContent: "center", paddingBottom: 24 }} xs={24}>
                {t("users")}
            </Col>
            <Row style={{ paddingBottom: 24 }}>
                <Col xs={24}>
                    <Card
                        bodyStyle={{ padding: "0px" }}
                        className="custom-card-head"
                        style={{ boxShadow: '0 4px 10px rgba(0, 0, 0, 0.25)', height: "100%" }}
                        title={<span className='base-card-header-title'>{t('users')}</span>}
                    >
                        <UsersTable />
                    </Card>
                </Col>
            </Row>
        </MainLayout>
    )
}

export default Users;